import { FileGlyph } from "./Icons"
import { HiddenField } from "../lib/rails"

export function RepositoryList({
  className = "",
  csrfToken,
  emptyText = "Try another repository name or request access in GitHub first.",
  emptyTitle = "No repositories found",
  onCloneStart,
  paths,
  repositories
}) {
  const visibleRepositories = repositories.slice(0, 24)

  return (
    <div className={`repository-picker slide-up ${className}`.trim()} id="repositories" style={{ animationDelay: "0.05s" }}>
      <div className="repository-list">
        {visibleRepositories.length > 0 ? (
          visibleRepositories.map((repository) => repository.repositoryPath ? (
            <a key={repository.fullName} href={repository.repositoryPath} className="repository-card">
              <RepositoryCardContent repository={repository} />
            </a>
          ) : (
            <form
              key={repository.fullName}
              action={paths.repositoryClone}
              method="post"
              className="repository-form"
              data-clone-form
              onSubmit={onCloneStart}
            >
              <HiddenField name="authenticity_token" value={csrfToken} />
              <HiddenField name="repository[full_name]" value={repository.fullName} />
              <button type="submit" className="repository-card">
                <RepositoryCardContent repository={repository} />
              </button>
            </form>
          ))
        ) : (
          <div className="empty-card">
            <div className="empty-title">No repositories found</div>
            <div className="empty-text">{emptyText}</div>
          </div>
        )}
      </div>
    </div>
  )
}

function RepositoryCardContent({ repository }) {
  return (
    <>
      <span className="repository-icon" aria-hidden="true">
        <FileGlyph folder />
      </span>
      <span className="repository-copy">
        <span className="repository-name">{repository.fullName}</span>
        <span className="repository-description">{repositoryMetadata(repository)}</span>
      </span>
      <span className="chevron" aria-hidden="true"></span>
    </>
  )
}

function repositoryMetadata(repository) {
  if (repository.private === false) return repository.repositoryPath ? "Open shared public repository" : "Public · Shared with everyone signed in"

  if (repository.repositoryPath) return "Open in Conceptive"

  const updatedAt = repository.pushedAt || repository.updatedAt
  const ownerLogin = repository.ownerLogin

  if (updatedAt && ownerLogin) return `Updated ${formatDateLabel(updatedAt)} by ${ownerLogin}`
  if (updatedAt) return `Updated ${formatDateLabel(updatedAt)}`
  if (repository.codeFileCount) return `${repository.codeFileCount} code files`
  if (repository.description) return repository.description

  return "Ready to review in Conceptive"
}

function formatDateLabel(value) {
  const date = new Date(value)
  if (Number.isNaN(date.valueOf())) return "recently"

  return date.toLocaleDateString("en-US", {
    day: "numeric",
    month: "short",
    timeZone: "UTC",
    year: "numeric"
  })
}

export function FileList({ entries }) {
  return (
    <div className="file-list">
      {entries.map((entry) => (
        <div className="file-row" key={`${entry.name}-${entry.kind}`}>
          <span className="file-icon" aria-hidden="true">
            <FileGlyph folder={entry.folder} />
          </span>
          <span className="file-name">{entry.name}</span>
          <span className="file-kind">{entry.kind}</span>
        </div>
      ))}
    </div>
  )
}
